"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var view_models_1 = require("./../view-models");
var view_config_models_1 = require("./../view-config-models");
var validators_1 = require("./../validators");
var AddressComponent = (function () {
    function AddressComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.formInitialized = false;
    }
    AddressComponent.prototype.ngOnChanges = function (changes) {
        if (!this.formInitialized && this.form && this.address && this.addressConfiguration) {
            this.buildForm();
        }
        if (changes['addressConfiguration']) {
            this.generateValidationMessages(this.addressConfiguration);
        }
    };
    AddressComponent.prototype.buildForm = function () {
        this.buildAddress1Control();
        this.buildAddress2Control();
        this.buildCityControl();
        this.buildStateOrProvinceControl();
        this.buildPostalCodeControl();
        this.formInitialized = true;
    };
    AddressComponent.prototype.generateValidationMessages = function (config) {
        if (config) {
            this.validationMessages = {
                'address1': {
                    'required': 'Address Line 1 is required.',
                    'maxlength': "Max length for Address Line 1 is " + config.address1MaxLength + " characters."
                },
                'address2': {
                    'maxlength': "Max length for Address Line 2 is " + config.address2MaxLength + " characters."
                },
                'city': {
                    'required': 'City is required.',
                    'maxlength': "Max length for City is " + config.cityMaxLength + " characters."
                },
                'stateOrProvince': {
                    'required': 'State is required.'
                },
                'postalCode': {
                    'required': 'Postal Code is required.',
                    'invalid': 'Postal Code must only contain digits.',
                    'length': "Postal Code must be exactly " + config.postalCodeLength + " digits."
                }
            };
        }
    };
    AddressComponent.prototype.buildAddress1Control = function () {
        if (this.addressConfiguration.address.show) {
            var validators = [];
            if (this.addressConfiguration.address.required) {
                validators.push(forms_1.Validators.required);
            }
            validators.push(forms_1.Validators.maxLength(this.addressConfiguration.address1MaxLength));
            this.form.addControl('address1', this.formBuilder.control(this.address.address1, forms_1.Validators.compose(validators)));
        }
    };
    AddressComponent.prototype.buildAddress2Control = function () {
        if (this.addressConfiguration.address.show) {
            var validators = [];
            validators.push(forms_1.Validators.maxLength(this.addressConfiguration.address2MaxLength));
            this.form.addControl('address2', this.formBuilder.control(this.address.address2, forms_1.Validators.compose(validators)));
        }
    };
    AddressComponent.prototype.buildCityControl = function () {
        if (this.addressConfiguration.address.show) {
            var validators = [];
            if (this.addressConfiguration.address.required) {
                validators.push(forms_1.Validators.required);
            }
            validators.push(forms_1.Validators.maxLength(this.addressConfiguration.cityMaxLength));
            this.form.addControl('city', this.formBuilder.control({ disabled: true, value: this.address.city }, forms_1.Validators.compose(validators)));
        }
    };
    AddressComponent.prototype.buildStateOrProvinceControl = function () {
        if (this.addressConfiguration.address.show) {
            var stateOrProvinceControlName = 'stateOrProvince';
            var validators = [];
            if (this.addressConfiguration.address.required) {
                validators.push(forms_1.Validators.required);
            }
            this.form.addControl(stateOrProvinceControlName, this.formBuilder.control({ disabled: !this.addressConfiguration.stateOrProvinceEnabled, value: this.address.stateOrProvince }, forms_1.Validators.compose(validators)));
        }
    };
    AddressComponent.prototype.buildPostalCodeControl = function () {
        if (this.addressConfiguration.address.show) {
            var validators = [];
            if (this.addressConfiguration.address.required) {
                validators.push(forms_1.Validators.required);
            }
            validators.push(validators_1.postalCodeValidator(this.addressConfiguration.postalCodeLength));
            this.form.addControl('postalCode', this.formBuilder.control(this.address.postalCode, forms_1.Validators.compose(validators)));
        }
    };
    return AddressComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", forms_1.FormGroup)
], AddressComponent.prototype, "form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], AddressComponent.prototype, "submitted", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.AddressViewModel)
], AddressComponent.prototype, "address", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], AddressComponent.prototype, "states", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", view_config_models_1.AddressViewConfig)
], AddressComponent.prototype, "addressConfiguration", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AddressComponent.prototype, "additionalPostalCodeError", void 0);
AddressComponent = __decorate([
    core_1.Component({
        selector: 'address',
        template: "<form *ngIf=\"addressConfiguration && formInitialized\" [formGroup]=\"form\" novalidate>     <div class=\"row\">         <div *ngIf=\"addressConfiguration.address.show\" class=\"col-xs-12 form-group\">             <label for=\"address1\">Address Line 1</label>             <input                 type=\"text\"                 class=\"form-control traveler-detail-address1\"                 formControlName=\"address1\">             <validation-messages                 [control]=\"form.controls.address1\"                 [messages]=\"validationMessages.address1\"                 [submitted]=\"submitted\"></validation-messages>         </div>     </div>     <div class=\"row\">         <div *ngIf=\"addressConfiguration.address.show\" class=\"col-xs-12 form-group\">             <label for=\"address2\">Address Line 2</label>             <input                 type=\"text\"                 class=\"form-control traveler-detail-address2\"                 formControlName=\"address2\">             <validation-messages                 [control]=\"form.controls.address2\"                 [messages]=\"validationMessages.address2\"                 [submitted]=\"submitted\"></validation-messages>         </div>     </div>     <div class=\"row\">         <div *ngIf=\"addressConfiguration.address.show\" class=\"col-xs-3 form-group\">             <label for=\"postalCode\">Postal Code</label>             <input                 type=\"tel\"                 class=\"form-control traveler-detail-postalCode\"                 formControlName=\"postalCode\">             <validation-messages                 [control]=\"form.controls.postalCode\"                 [messages]=\"validationMessages.postalCode\"                 [submitted]=\"submitted\"></validation-messages>             <div *ngIf=\"additionalPostalCodeError\">                 <span class=\"help-block haserrorfieldlevel\">                     {{ additionalPostalCodeError }}                 </span>             </div>         </div>         <div *ngIf=\"addressConfiguration.address.show\" class=\"col-xs-6 form-group\">             <label for=\"city\">City</label>             <input                 type=\"text\"                 class=\"form-control traveler-detail-city\"                 formControlName=\"city\">             <validation-messages                 [control]=\"form.controls.city\"                 [messages]=\"validationMessages.city\"                 [submitted]=\"submitted\"></validation-messages>         </div>         <div *ngIf=\"addressConfiguration.address.show\" class=\"col-xs-3 form-group\">             <label for=\"stateOrProvince\">State</label>             <select                 class=\"form-control traveler-detail-stateOrProvince\"                 formControlName=\"stateOrProvince\">                 <option value=\"\">Select</option>                 <option *ngFor=\"let state of states\" value=\"{{state.isoCode2}}\">{{state.name}}</option>             </select>             <validation-messages                 [control]=\"form.controls.stateOrProvince\"                 [messages]=\"validationMessages.stateOrProvince\"                 [submitted]=\"submitted\"></validation-messages>         </div>     </div> </form>"
    }),
    __metadata("design:paramtypes", [forms_1.FormBuilder])
], AddressComponent);
exports.AddressComponent = AddressComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/address/address.component.js